import "core-js/modules/es.string.link.js";
import React from 'react';
import { Link } from 'react-router-dom';
import Pill from 'components/Pill';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TagPill(_ref) {
  var children = _ref.children,
    link = _ref.link;
  if (!link) {
    return /*#__PURE__*/_jsx(Pill, {
      icon: "tag",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Pill, {
    icon: "tag",
    as: Link,
    to: link,
    children: children
  });
}